import React, { PureComponent } from 'react';
import { SocialButtons } from '../index';
import { IMAGES_REPO } from '../../config';

class TeamMember extends PureComponent {

  render() {
    const { id, body, name, photo, description, follow } = this.props;
    return (
      <div className="team-member">
        <div className="information">
          <img
            className="img-responsive img-circle"
            src={`${IMAGES_REPO}${photo}`}
            alt={`Team menber ${id}`}/>
          <h4>{name}</h4>
          <p className="text-muted">{description}</p>
          <div dangerouslySetInnerHTML={{ __html: body }}/>
        </div>
        <div className="shared">
          {follow && <SocialButtons follow={follow}/>}
        </div>
      </div>
    );
  }
}

TeamMember.propTypes = {};
TeamMember.defaultProps = {};

export default TeamMember;



// WEBPACK FOOTER //
// ./src/components/teamMember/TeamMember.js